export const iconFontAwesomeMoneyMillSign = (
	<i className="fa-solid fa-mill-sign"></i>
);
